import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import APIConfig from "../../../../api/APIConfig";
import { useState, useEffect } from 'react';
import Form from "react-validation/build/form";
import { Alert } from 'react-bootstrap';
import swal from 'sweetalert';
import classes from "./styles.module.css"; 
import {
    Box,
    Center,
    Heading,
    Button,
    Stack,
    Text,
    VStack,
    useColorModeValue,
    FormControl,
    FormLabel,
    Input,
} from '@chakra-ui/react';


function FormMediaSosialPeserta() {
    const navigate = useNavigate();
    const [instagram, setInstagram] = useState('');
    const [linkedin, setLinkedin]= useState('');
    const [github, setGithub] = useState('');
    const [validation, setValidation] = useState({});
    const { id } = useParams();
    useEffect(() => {
        getPesertaById();
        
    }, []);

    const getPesertaById = async() => {
        const response = await APIConfig.get(`/v1/peserta/${id}`);
        const data = await response.data
        setInstagram(data.instagram);
        setLinkedin(data.linkedin);
        setGithub(data.github);
    };

    const updateMediaSosial = async (e) => {
        e.preventDefault();
        swal("Apakah Anda yakin ingin mengubah media sosial?", {
            buttons: {
                yes: {
                text: "Ya",
                value: "yes"
                },
                no: {
                text: "Kembali",
                value: "no"
                }
        }
        }).then((value) => {
            if (value === "yes") {
                APIConfig.put(`v1/medsos/peserta/${id}`, {
                    instagram: instagram,
                    linkedin: linkedin,
                    github: github
                })
                swal({
                    title: "Media sosial berhasil tersimpan!",
                    icon: "success",
                    button: "OK",
                }).then(() => {
                    navigate(`/peserta/profile/mediasosial/${id}`)
                })
            }
        });
    };

    return (
        <Center py={6}>
        <VStack justifyItems='left' fontFamily={'Inter'}>
            <Text
                pt={10}
                paddingBottom={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}
                letterSpacing={1.1}
                fontFamily={'Inter'}>
                Edit Profil
            </Text>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                bg={useColorModeValue('white', 'gray.900')}
                rounded={'2xl'}
                p={6}
                className={classes.box}
                overflow={'hidden'}>
                <VStack 
                spacing={4}
                align='stretch'
                p={3}
                >
                    <Heading
                        mb={6}
                        mt={3}
                        color={useColorModeValue('gray.700', 'white')}
                        fontSize={'xl'}
                        fontFamily={'Inter'}>
                        Media Sosial
                    </Heading>

                    {
                        validation.errors &&
                            <Alert variant="danger">
                                <ul class="mt-0 mb-0">
                                    { validation.errors.map((error, index) => (
                                        <li key={index}>{ `${error.param} : ${error.msg}` }</li>
                                    )) }
                                </ul>
                            </Alert>
                    }
                    
                    <Form pb={6} onSubmit={updateMediaSosial}>
                        <FormControl pb={6} fontFamily={'Inter'}>
                        <FormLabel htmlFor='instagram'>Instagram</FormLabel>
                        <Input id='instagram' 
                        placeholder='Masukkan link' 
                        value={instagram}
                        onChange={(e) => setInstagram(e.target.value)}/>
                        </FormControl>

                        <FormControl pb={6} fontFamily={'Inter'}>
                        <FormLabel htmlFor='linkedin'>LinkedIn</FormLabel>
                        <Input id='linkedin' placeholder='Masukkan link' 
                        value={linkedin}
                        onChange={(e) => setLinkedin(e.target.value)}/>
                        </FormControl>

                        <FormControl pb={6} fontFamily={'Inter'}>
                        <FormLabel htmlFor='github'>Github</FormLabel>
                        <Input id='github' 
                        placeholder='Masukkan link' 
                        value={github}
                        onChange={(e) => setGithub(e.target.value)}/>
                        </FormControl>

                        <Stack pt={6} justifyContent='right' direction='row' spacing={4} align='center'>
                            <Button 
                                onClick={() => navigate(-1)}
                                p={6} rounded={'xl'} colorScheme='purple' variant='outline'>
                                Kembali
                            </Button>
                            <Button 
                                type='submit'
                                p={6}
                                colorScheme='purple' 
                                rounded={'xl'}
                                variant='solid'>
                                Simpan
                            </Button>
                        </Stack>
                    </Form>
                </VStack>
            </Box>
        </VStack>
        </Center>
    );
}

export default FormMediaSosialPeserta;